import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://pdxxdgrexhuvssbsysqa.supabase.co";
const SUPABASE_KEY = "sb_publishable_NgMmWxHQYiIrxh1PCUbTow_bLWKEvsY";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
